export const formatDateToYYYYMMDD = ({
  $y,
  $M,
  $D,
}: {
  $y: number;
  $M: number;
  $D: number;
}) => {
  const month = String($M + 1).padStart(2, "0");
  const day = String($D).padStart(2, "0");
  return `${$y}-${month}-${day}`;
};

export const convertToIST = (dateString: string): string => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Kolkata",
      hour12: true,
    };

    return new Intl.DateTimeFormat("en-IN", options).format(date);
  } catch (error) {
    console.error("Error converting to IST:", error);
    return dateString;
  }
};
